import React, { Component } from "react";
import * as router from "react-router-redux";
import { connect } from "react-redux";
import { actions } from "./redux";
import CSSModules from "react-css-modules";
import { Grid, Hidden } from "@material-ui/core";

import styles from "./styles.scss";
import { color } from "@material-ui/core/colors";

import {shouldUpdate} from '../../../../utils';

let count = 0;
const idPrefix = "hourlyFailureHeatMap";

@CSSModules(styles, { allowMultiple: true })
class HourlyFailureHeatMap extends Component {
    constructor(props){
        super(props);
        this.props.initComponent(this.props.id, this.props.component);
    }
	render() {
        if(!this.props.componentData || !this.props.componentData.hourlyFailures){
            return null;
        }
        //attempting to implement responsiveness all in the same grid results in rounding errors which leaves
        //1px white lines ranomdly in the heatmap.
        //To solve, separate layouts are used for each screen size needed
        let xsMultiples = [0,1,2,3];
        let smMultiples = [0,1];
		return (
            <div styleName="component-wrapper">
                <div styleName="component-title">
					 {this.props.component.chartTitle ||
                    "Distribution of samples outside range in relation to time of day for reporting period"}
                </div>
                <Grid container spacing={0}>

                    {/*XS screen size*/}
                    <Hidden smUp>
                    {xsMultiples.map((multiple)=>
                        <Grid item xs={12} key={multiple}>
                            <div styleName="heatmap-container">
                            {this.props.componentData.hourlyFailures.slice(multiple * 6, (multiple + 1) * 6).map((hourlyFailure, index) =>
                                this.getHeatMapFragment(hourlyFailure, index)
                            )}
                            </div>
                        </Grid>  
                    )}                       
                    </Hidden>

                    {/*SM screen size*/}
                    <Hidden mdUp xsDown>
                    {smMultiples.map((multiple)=>
                        <Grid item xs={12} key={multiple}>
                            <div styleName="heatmap-container">
                            {this.props.componentData.hourlyFailures.slice(multiple * 12, (multiple + 1) * 12).map((hourlyFailure, index) =>
                                this.getHeatMapFragment(hourlyFailure, index)
                            )}
                            </div>
                        </Grid>  
                    )}                       
                    </Hidden>

                    {/*MD and higher screen sizes*/}
                    <Hidden smDown>
                        <Grid item xs={12}>
                            <div styleName="heatmap-container">
                            {this.props.componentData.hourlyFailures.map((hourlyFailure, index) =>
                                this.getHeatMapFragment(hourlyFailure, index)
                            )}
                            </div>
                        </Grid>
                    </Hidden>
                </Grid>
            </div>
		);
    }

    setup(){
        this.props.loadData(this.props.id, this.props.component, this.props.timePeriod, this.props.onLoadComplete);
    }

    componentDidMount(){
        this.setup();
    }

    getHeatMapFragment(hourlyFailure, index){
        return (
            <div key={index} styleName="heatmap-fragment">
                <div styleName="heatmap-text">
                    {hourlyFailure.display}
                </div>
                <div style={{backgroundColor: hourlyFailure.color}} styleName="heatmap-color tooltip">
                    <span styleName="tooltiptext">Fail Count: {hourlyFailure.count}</span>
                </div>
            </div>
        );
    }

    componentDidUpdate(prevProps, prevState, snapshot){
        if(prevProps.componentData != this.props.componentData){
            return true;
        }else if(prevProps.component != this.props.component || prevProps.timePeriod != this.props.timePeriod){
            this.setup();
            return false;
        }else{
            return false;
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
		return shouldUpdate(this, nextProps, nextState, ["onLoadComplete"]);
	}

}

const bindAction = dispatch => {
    return {
        loadData: (id, component, timePeriod, onLoadComplete) => dispatch(actions.loadData(id, component, timePeriod, onLoadComplete)),
        initComponent: (id, component) => dispatch(actions.initComponent(id, component)),
    };
};

const mapStateToProps = (state, ownProps) => ({
    componentData: state.hourlyfailureheatmap.instances[ownProps.id],
});

//do this to merge classes
export default class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			wrapped: null
        };
        this.id = idPrefix + count;
        count++;
	}

	componentWillMount() {
		this.setState({
			wrapped: connect(mapStateToProps, bindAction)(HourlyFailureHeatMap)
		});
	}

	render() {
		const Elem = this.state.wrapped;
		return <Elem {...this.props} id={this.id} />;
    }
}



// WEBPACK FOOTER //
// ./src/components/ReportComponents/HeatMaps/HourlyFailureHeatMap/HourlyFailureHeatMap.js